import React from 'react'

const CheckedIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    fill="none"
    viewBox="0 0 66.402 45.434"
  >
    <path
      d="M64.867 1.536a5.236 5.236 0 0 1 0 7.41l-34.95 34.95a5.231 5.231 0 0 1-7.41 0l-20.97-20.97a5.24 5.24 0 0 1 7.41-7.41l17.264 17.259L57.457 1.536a5.236 5.236 0 0 1 7.41 0"
      fill={color}
    />
  </svg>
)

export default CheckedIcon
